export default {
  header: 'Questa settimana',
  metrics: {
    points: 'Punti',
    visits: 'Visite',
    in_store_sign_ups: 'Iscrizioni in negozio',
    rewards_redeemed: 'Premi riscattati',
  },
};
